export default {
  createANewRepair: "Create a new repair log",
  equipmentTag: "Asset Tag",
  createdBy: "Created by",
  log: "Log",
  submit: "Submit"
};
